import React from 'react'

const ModuleDocument = ({ name, type, link }) => {
    let image;

    if (type === 'pdf') {
        image = "https://insol.azureedge.net/cmsstorage/insol/media/education/icons/pdf-document.svg";
    } else if (type === 'word') {
        image = "https://insol.azureedge.net/cmsstorage/insol/media/education/icons/word-document.svg";
    } else {
        image = null;
    }

    return (
        <a className="block m" href={link} target="_blank" rel="noopener noreferrer">
            <div className="flex items-center mb-6">
                {image && <img src={image} height={35} className="mr-6" alt={`${type} document`} />}
                <span className="text-brandDarkBlue underline">{name}</span>
            </div>
        </a>
    );
};

export default ModuleDocument;